export const widgetTemplates = [
  {
    id: 'life-lessons',
    name: 'Life Lessons',
    description: 'A compact list of principles, lessons, or hard-earned truths.',
    visibility: 'public',
    fields: ['title', 'lessons'],
    defaultSettings: {
      title: 'Life Lessons',
      lessons: 'Start before you feel ready.\nProtect what makes you curious.\nTell the truth kindly.',
    },
  },
  {
    id: 'chapter-map',
    name: 'Chapter Map',
    description: 'Shows major life chapters as a clean visual index.',
    visibility: 'public',
    fields: ['chapters', 'activeChapter'],
    defaultSettings: {
      chapters: 'Beginnings\nBecoming\nA turning point\nNow',
      activeChapter: 'Now',
    },
  },
  {
    id: 'private-compass',
    name: 'Private Compass',
    description: 'A private planning block for goals, reflections, and next actions.',
    visibility: 'private',
    fields: ['focus', 'nextStep', 'notes'],
    defaultSettings: {
      focus: 'What matters this week?',
      nextStep: 'Choose one small action.',
      notes: 'Keep this private until it becomes part of the story.',
    },
  },
  {
    id: 'memory-game',
    name: 'Memory Game',
    description: 'A lightweight profile game with clues from your own history.',
    visibility: 'friends',
    fields: ['prompt', 'answers', 'correctAnswer'],
    defaultSettings: {
      prompt: 'Which one of these actually happened?',
      answers: 'I got lost on purpose.\nI changed my mind at the last second.\nI kept the ticket.',
      correctAnswer: 'I kept the ticket.',
    },
  },
];

export function getWidgetTemplate(templateId) {
  return widgetTemplates.find((template) => template.id === templateId) || null;
}

export function normalizeComponentTemplate(template, source = 'default') {
  return {
    ...template,
    kind: template.kind || 'profile-component',
    category: template.category || source,
    source: template.source || source,
    defaultSettings: template.defaultSettings || template.settings || {},
    nsfw: Boolean(template.nsfw),
    adult: Boolean(template.adult),
  };
}

export function marketplaceComponentTemplates(templates, options = {}) {
  const { includeAdult = false, source = 'default' } = options;
  return templates
    .map((template) => normalizeComponentTemplate(template, template.source || source))
    .filter((template) => includeAdult || (!template.nsfw && !template.adult));
}

export const visibilityOptions = [
  { value: 'public', label: 'Public', description: 'Visible to everyone.' },
  { value: 'friends', label: 'Friends', description: 'Visible to accepted friends.' },
  { value: 'group', label: 'Custom group', description: 'Visible to a selected privacy group.' },
  { value: 'private', label: 'Private', description: 'Visible only to you.' },
];
